// extracted by mini-css-extract-plugin
export default {"logo_container":"header_logo_container__seZVU","separator":"header_separator__vMiGc","header":"header_header__tGBRw","create_new_button":"header_create_new_button__WRd6F"};